import React, { type FC, useEffect, useMemo } from 'react';
import { useEntryPoint } from '@atlassian/jira-entry-point';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container';
import { useActiveRightSidebarState } from '@atlassian/jira-layout-controller';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src';
import { virtualAgentCreateIntentTemplateSidebarEntryPoint } from '@atlassian/jira-servicedesk-settings-virtual-agent-create-intent-templates-sidebar/entrypoint';
import { SideBarWrapper } from '@atlassian/jira-servicedesk-settings-virtual-agent-create-intent-templates-sidebar/src/ui';
import { ErrorDisplay } from '@atlassian/jira-servicedesk-settings-virtual-agent-create-intent-templates-sidebar/src/ui/content/error-display';
import { VirtualAgentIntentTemplateSidebarSkeleton } from '@atlassian/jira-skeletons';
import { useCloudId } from '@atlassian/jira-tenant-context-controller';

const runtimeProps = {};
export const IntentTemplatesSidebar: FC = () => {
	const rightSidebarCurrentState = useActiveRightSidebarState();
	const panelId = rightSidebarCurrentState?.panelId ?? '';
	const cloudId = useCloudId();
	const { data: projectContextData } = useProjectContext();

	const entryPointParams = useMemo(
		() => ({
			cloudId,
			key: projectContextData?.projectKey ?? '',
		}),
		[cloudId, projectContextData],
	);
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		virtualAgentCreateIntentTemplateSidebarEntryPoint,
		entryPointParams,
	);

	useEffect(() => {
		if (panelId === 'intentTemplate') {
			entryPointActions.load();
		} else {
			entryPointActions.unload();
		}
	}, [entryPointActions, panelId]);

	return (
		<JiraEntryPointContainer
			id="createIntentTemplatesSidebar"
			packageName="jiraServicedeskSettingsVirtualAgentCreateIntentTemplates"
			entryPointReferenceSubject={entryPointReferenceSubject}
			fallback={<VirtualAgentIntentTemplateSidebarSkeleton />}
			errorFallback={() => (
				<SideBarWrapper>
					<ErrorDisplay refetch={() => window.location.reload()} />
				</SideBarWrapper>
			)}
			runtimeProps={runtimeProps}
		/>
	);
};

export default IntentTemplatesSidebar;
